import { create } from "zustand";
import {
  getStage4Notifications,
  markStage4NotificationRead,
  Stage4Notification,
} from "../api/companyExcelOnboarding";

type Stage4NotificationsState = {
  notifications: Stage4Notification[];
  load: () => Promise<void>;
  markRead: (id: string) => Promise<void>;
  clear: (id: string) => Promise<void>;
  clearAll: () => Promise<void>;
};

export const useStage4NotificationsStore = create<Stage4NotificationsState>(
  (set, get) => ({
    notifications: [],
    load: async () => set({ notifications: await getStage4Notifications() }),
    markRead: async (id) => {
      await markStage4NotificationRead(id);
      set((state) => ({
        notifications: state.notifications.map((notification) =>
          notification.id === id
            ? { ...notification, isRead: true }
            : notification
        ),
      }));
    },
    clear: async (id) => {
      await markStage4NotificationRead(id);
      set((state) => ({
        notifications: state.notifications.filter(
          (notification) => notification.id !== id
        ),
      }));
    },
    clearAll: async () => {
      await Promise.all(
        get().notifications.map((notification) =>
          markStage4NotificationRead(notification.id)
        )
      );
      set({ notifications: [] });
    },
  })
);
